// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddProject_wrapper__sXCpr","head":"ModalAddProject_head__2bsWH","content":"ModalAddProject_content__pemBx"};